import React, { useEffect, useState } from 'react';
import { Button, FormControlLabel, Switch } from '@material-ui/core';
import { Col, Row } from 'react-bootstrap';
import { reduxForm, Field } from 'redux-form';
import InputField from 'components/forms/reduxForm/InputField';
import { validateEmail, required } from 'tools/forms/validators';
import strings from 'strings';
import { Toast } from 'components/shared/Toaster'
import { getNotificationDetails, updateNotificationDetails } from "../../../../actions/client";

const NotificationForm = ({ handleSubmit, initialize }) => {
    const [loading, setLoading] = useState(false);
    const [isSwitchChecked, setIsSwitchChecked] = useState(false);
    // Tasks live in the activity dashboard, so the task email switch only shows with it. Read from the
    // settings response, not the login session, so a change made since sign-in shows right away.
    const [activityDashboardEnabled, setActivityDashboardEnabled] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getNotificationDetails();
            initialize({
                email: data.email,
                uccStatusNotificationEnabled: data.uccStatusNotificationEnabled,
                taskAssignmentEmails: !!data.taskAssignmentEmails,
            });
            setIsSwitchChecked(data.uccStatusNotificationEnabled);
            setActivityDashboardEnabled(!!data.activityDashboardEnabled);
        };
        fetchData();
    }, [initialize]);

    const submitForm = async (values) => {
        setLoading(true);
        try {
            await updateNotificationDetails(values);
        } finally {
            Toast({ type: "success", message: strings.NOTIFICATION_FORM.NOTIFICATION_SETTINGS_SAVED_SUCCESSFULLY })
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit(submitForm)}>
            <Col md={6} className="text-left">
                <h6>{strings.NOTIFICATION_FORM.NOTIFICATION_SETTINGS}</h6>

                <InputField
                    name="email"
                    label={strings.NOTIFICATION_FORM.EMAIL}
                    validate={isSwitchChecked?[validateEmail, required]:[validateEmail]}
                
                />

                <Field
                    name="uccStatusNotificationEnabled"
                    component={({ input }) => (
                        <FormControlLabel
                            className='mt-3'
                            control={
                                <Switch
                                    checked={!!input.value}
                                    onChange={e => {
                                        input.onChange(e);
                                        setIsSwitchChecked(e.target.checked);
                                    }}
                                    color="primary"
                                />
                            }
                            label={input.value ? strings.NOTIFICATION_FORM.UCC_NOTIFICATIONS_ENABLED : strings.NOTIFICATION_FORM.UCC_NOTIFICATIONS_DISABLED}
                        />
                    )}
                />
                <p className='mt-1 mb-0' style={{ color: 'var(--fg-secondary)', fontSize: '0.875rem' }}>
                    {strings.NOTIFICATION_FORM.UCC_NOTIFICATIONS_HINT}
                </p>

                {activityDashboardEnabled && (
                    <>
                        <Field
                            name="taskAssignmentEmails"
                            component={({ input }) => (
                                <FormControlLabel
                                    className='mt-3'
                                    control={
                                        <Switch
                                            checked={!!input.value}
                                            onChange={e => input.onChange(e.target.checked)}
                                            color="primary"
                                        />
                                    }
                                    label={strings.NOTIFICATION_FORM.TASK_ASSIGNMENT_EMAILS}
                                />
                            )}
                        />
                        <p className='mt-1 mb-0' style={{ color: 'var(--fg-secondary)', fontSize: '0.875rem' }}>
                            {strings.NOTIFICATION_FORM.TASK_ASSIGNMENT_EMAILS_HINT}
                        </p>
                    </>
                )}
            </Col>
            <Row className="p-2">
                <Col md={6} className="text-right">
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? strings.NOTIFICATION_FORM.SAVING : strings.NOTIFICATION_FORM.SAVE}
                    </Button>
                </Col>
            </Row>
        </form>
    );
};

export default reduxForm({ form: "notificationForm" })(NotificationForm);
